import { Component, inject } from '@angular/core';
import { Events, injectDispatch } from '@ngrx/signals/events';
import { authEvents } from '@navstation-portal/shared/data-access/auth';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoginFooterComponent } from './login-footer/login-footer.component';
import { LoginContentComponent } from './login-content/login-content.component';

@Component({
  selector: 're-login-page',
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css',
  imports: [LoginFooterComponent, LoginContentComponent],
})
export class LoginPageComponent {
  version = environment.appVersion;
  buildDate = 'aDateInThePast';
  baseUrl = 'someURL';
  qaBuild = false;
  message!: string;

  readonly authDispatch = injectDispatch(authEvents);
  readonly events = inject(Events);
  readonly router = inject(Router);

  constructor() {
    this.events
      .on(authEvents.loginSuccess)
      .pipe(takeUntilDestroyed())
      .subscribe(({ payload: loginResponse }) => {
        const vesselId = loginResponse.selectedVessel.id;
        const route = ['site'];
        if (vesselId) route.push(vesselId);
        route.push('crew-dashboard');
        this.router.navigate(route);
      });
  }

  onLoginSubmit = (username: string, password: string) => {
    if (typeof username !== 'string' || typeof password !== 'string') return;

    this.authDispatch.login({ username, password });
  };
}
